module.exports = __webpack_public_path__ + "Worldline-Coconut-Symbol.55d395396d5bf08dd718c54fffcc1631.png";